import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=58d3eee2&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"
import style0 from "./Download.vue?vue&type=style&index=0&id=58d3eee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3eee2",
  null
  
)

export default component.exports